export default (state = true, action) => {
  switch (action.type) {
    case 'SHOW_RIGHTRAIL':
      return window.innerWidth >= 1334;
    default:
      return state;
  }
};
